// Constants for different requests for current reducer
export default {
  planList: 'PLAN_LIST',
  
  AREA: 'area',
  CHECKPOINT: 'checkpoint',
  SITE: 'site'
};
